export var status_dot = `
<div class="hover-show-explanation group-status-dot {{#if active}}active cursor-pointer{{/if}}"
    group_id="{{group_id}}"
    title='{{#if active }}{{i18n 'operation.group.click_to_access_your_group'}}{{^}}{{i18n 'operation.group.not_a_member_of_any_groups'}}{{/if}}'
    data-toggle="tooltip">
</div>
`